import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography, IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { genfunction } from 'helpers'
import ReactHtmlParser from 'react-html-parser';
import { useLocation } from "react-router-dom";
import InfoIcon from '@material-ui/icons/Info'
import moment from 'moment';

import { actionShopcartResetOrderProducts } from 'actions'
import ErrorHandling from 'components/ErrorHandling/ErrorHandling';

const { } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: 10,
        paddingBottom: 10
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    titleText: {
        paddingLeft: 5,
        paddingRight: 5
    },
    subTitleText: {
        paddingLeft: 5,
        paddingRight: 5
    },
    button: {
        width: 130
    }
}));

const OrderLocationItem = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { Location } = props;

    const getStoreOpenDays = () => {
        let openDays = "";
        if (Location.OpeningTimes) {
            openDays = Location.OpeningTimes[0].Day.substr(0, 3);
            if (Location.OpeningTimes.length > 0) {
                openDays += " - " + Location.OpeningTimes[Location.OpeningTimes.length - 1].Day.substr(0, 3);
            }
        }

        return openDays;
    }

    const getDayOfWeek = (date) => {
        const dayOfWeek = new Date(date).getDay();
        return isNaN(dayOfWeek) ? null :
            ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
    }

    const getStoreOpenTimes = () => {
        let openDaysTime = "";
        let day = getDayOfWeek(Date.now());
        if (Location.OpeningTimes && Location.OpeningTimes.length > 0) {
            let times = Location.OpeningTimes.find(x => x.Day.toUpperCase() == day.toUpperCase());
            if (times) {
                let storeOpenTime = moment(moment().format("DD-MMM-YYYY ") + Location.OpeningTimes[0].Open);
                let storeCloseTime = moment(moment().format("DD-MMM-YYYY ") + Location.OpeningTimes[0].Close);
                openDaysTime = "Open Today : " + storeOpenTime.format("hh:mm a") + " - " + storeCloseTime.format("hh:mm a")
            }
        }

        return openDaysTime;
    }

    const isStoreOpenNow = () => {
        let isOpen = false;
        let day = getDayOfWeek(Date.now());
        if (Location.OpeningTimes && Location.OpeningTimes.length > 0) {
            let times = Location.OpeningTimes.find(x => x.Day.toUpperCase() == day.toUpperCase());
            if (times) {
                let storeOpenTime = moment(moment().format("DD-MMM-YYYY ") + Location.OpeningTimes[0].Open);
                let storeCloseTime = moment(moment().format("DD-MMM-YYYY ") + Location.OpeningTimes[0].Close);
                let now = moment();
                if (now > storeOpenTime && now < storeCloseTime) {
                    isOpen = true;
                }
            }
        }

        return isOpen;
    }

    const onClickStoreHandler = () => {
        actionShopcartResetOrderProducts(dispatch);
        props.history.push('/orderlocationtab/' + Location.OrderLocation);
    }


    return (
        <Grid className={classes.root} key={Location.OrderLocation} container spacing={1}>
            <Grid container item xs={8}>
                <Grid item sm={11} xs={12}>
                    <Typography className={classes.titleText} variant="h5" color="textPrimary" >{Location.OrderLocation}</Typography>
                    <Typography className={classes.subTitleText} variant="subtitle1" color="textPrimary" >{getStoreOpenTimes()}</Typography>
                    {Location.AverageWaitMinutes ?
                        <Typography className={classes.subTitleText} variant="subtitle1" color="textPrimary" >{"Avg Wait Time : " + Location.AverageWaitMinutes + " minutes"}</Typography> : ""}
                </Grid>
            </Grid>

            <Grid item xs={4} align="right">
                <Button className={classes.button} variant='contained' color='primary'
                    onClick={onClickStoreHandler}
                    disabled={isStoreOpenNow() ? false : true}>
                    {isStoreOpenNow() ? 'Order Now' : "Not Open"}
                </Button>
            </Grid>
        </Grid>
    );
};

export default OrderLocationItem;
